import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-black text-gray-500 py-12 px-4 text-center text-sm" data-id="element-154">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-155">
        <p className="font-bold text-gray-400" data-id="element-156">
          © Reset de Dopamina · Todos los derechos reservados
        </p>
        <p data-id="element-157">Producto digital · PDF descargable · Acceso inmediato</p>
        <p className="text-xs max-w-2xl mx-auto mt-8 opacity-70" data-id="element-158">
          Este producto es material educativo e informativo. No reemplaza el
          diagnóstico ni el tratamiento de un profesional de la salud.
        </p>
      </div>
    </footer>;
};